module.exports = __webpack_public_path__ + "static/img/ko.6bf643ae.png";